"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

exports.__esModule = true;
exports.pureTranslate = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useDictionary = _interopRequireDefault(require("../hooks/useDictionary"));

var _enGB = _interopRequireDefault(require("../data/dictionary/en-GB.json"));

const pureTranslate = (translations, key, values = {}) => {
  const translation = translations[key] || _enGB.default[key];
  if (!translation) return key;
  return Object.keys(values).reduce((acc, placeholder) => acc.replace(new RegExp(`__${placeholder}__`, "g"), String(values[placeholder])), translation);
};

exports.pureTranslate = pureTranslate;

const Translate = ({
  tKey,
  values
}) => {
  const dictionary = (0, _useDictionary.default)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pureTranslate(dictionary, tKey, values));
};

var _default = Translate;
exports.default = _default;